import moment from 'moment';
import React, { useState } from 'react';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'; // icons

const toInvoiceArray = (raw) => {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw !== 'object') return [];
  if (Array.isArray(raw.data)) return raw.data;
  if (Array.isArray(raw.Data)) return raw.Data;
  if (Array.isArray(raw.rows)) return raw.rows;
  if (Array.isArray(raw.Rows)) return raw.Rows;
  const keys = Object.keys(raw);
  if (keys.length && keys.every((k) => /^\d+$/.test(k))) {
    return keys
      .sort((a, b) => Number(a) - Number(b))
      .map((k) => raw[k])
      .filter(Boolean);
  }
  return [raw];
};

const PaymentInvoices = ({ InvoiceList }) => {
  const { currencyPrecision } = useCurrency();
  const invoices = toInvoiceArray(InvoiceList);
  let rentList = invoices.filter((issue) => issue.Category === 'Rent');
  let otherList = invoices.filter((issue) => issue.Category === 'Other');

  // Calculate total of Exp2
  const [showRent, setShowRent] = useState(true);
  //  rent calculated
  const rentAmount = invoices
    .reduce((sum, item) => sum + parseFloat(item.Amount || item.Total - item.VAT || 0), 0)
    .toFixed(currencyPrecision?.decimalNumbers || 2);
  const rentVat = invoices.reduce((sum, item) => sum + parseFloat(item.VAT || 0), 0).toFixed(currencyPrecision?.decimalNumbers || 2);
  const renttotal = invoices.reduce((sum, item) => sum + parseFloat(item.Total || 0), 0).toFixed(currencyPrecision?.decimalNumbers || 2);

  return (
    <div className="gridshad mt-2 mb-3">
      <div className="table-container" style={{ overflowX: 'auto', height: 'auto' }}>
        <table>
          <thead className="dynoTable">
            <tr>
              <th>Description</th>
              <th>Due Date</th>
              <th>Rent</th>
              <th>VAT Percent</th>
              <th>VAT Amount</th>
              <th>Total Amount</th>
            </tr>
          </thead>

          {/* Rent Section */}
          <tbody>
            <tr>
              <td
                colSpan={9}
                className="font-bold bg-light p-2 cursor-pointer"
                style={{ cursor: 'pointer', background: '#f5f5f5' }}
                onClick={() => setShowRent(!showRent)}
              >
                <div style={{ display: 'flex', alignItems: 'center' }} className="gap-3">
                  <span>Rent</span>
                  {showRent ? <FaChevronUp /> : <FaChevronDown />}
                </div>
              </td>
            </tr>
            {showRent && (
              <>
                {invoices.map((data, index) => (
                  <tr key={index}>
                    <td>
                      <input className="p-1" value={data?.Installment_Desc || data?.Description} disabled style={{ width: '500px' }} />
                    </td>
                    <td>
                      <input className="p-1" value={moment(data?.DueDate).format('DD-MMM-YYYY')} disabled style={{ width: '100%' }} />
                    </td>
                    <td>
                      <input
                        className="p-1"
                        value={(data?.Amount || data?.Total - data?.VAT)?.toFixed(currencyPrecision?.decimalNumbers || 2)}
                        disabled
                        style={{ width: '100%' }}
                      />
                    </td>
                    <td>
                      <input className="p-1" value={data?.VATPercent?.toFixed(currencyPrecision?.decimalNumbers || 2)} disabled style={{ width: '100%' }} />
                    </td>
                    <td>
                      <input className="p-1" value={data?.VAT?.toFixed(currencyPrecision?.decimalNumbers || 2)} disabled style={{ width: '100%' }} />
                    </td>
                    <td>
                      <input className="p-1" value={data?.Total?.toFixed(currencyPrecision?.decimalNumbers || 2)} disabled style={{ width: '100%' }} />
                    </td>
                  </tr>
                ))}
                <tr>
                  <td>
                    <input className="p-1 w-100" disabled />
                  </td>
                  <td>
                    <input className="p-1 w-100" disabled />
                  </td>
                  <td>
                    <input className="p-1 w-100" disabled value={rentAmount || '0.000'} />
                  </td>
                  <td>
                    <input className="p-1 w-100" disabled />
                  </td>
                  <td>
                    <input className="p-1 w-100" disabled value={rentVat || '0.000'} />
                  </td>
                  <td>
                    <input className="p-1 w-100" disabled value={renttotal || '0.000'} />
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentInvoices;
